import { tv } from 'tailwind-variants';

export const toastRecipe = tv({
  slots: {
    root: 'flex items-center rounded-lg shadow-brand-400 text-sm p-3 font-medium',
    actionContainer: 'ml-2 flex items-center gap-0.5',
    action: 'cursor-pointer px-3 py-1.5 font-medium',
    closeButton: 'cursor-pointer',
  },
  variants: {
    type: {
      default: {
        root: 'bg-brand-gray-16 text-brand-gray-8',
      },
      error: {
        root: 'bg-brand-red-12 text-brand-red-1',
      },
    },
  },
  defaultVariants: {
    type: 'default',
  },
});
